export default __webpack_public_path__ + "static/media/marienplatz.6bc33b02.jpg";